import React from 'react';
import { categoryOf } from '../../config/serviceCategories';

const SIZES = {
  sm: { box: 'w-8 h-8', icon: 16 },
  md: { box: 'w-10 h-10', icon: 20 },
};

/**
 * The icon of a WP3 service: its category's glyph on the category tint, the
 * same wherever a service is shown. `size` follows the density of the card.
 */
export const ServiceIcon = ({ categoryKey, size = 'sm' }) => {
  const category = categoryOf(categoryKey);
  const Icon = category.icon;
  const { box, icon } = SIZES[size] || SIZES.sm;
  return (
    <span
      className={`${box} rounded-[8px] flex items-center justify-center flex-shrink-0`}
      style={{ background: category.tint, color: category.color }}
      aria-hidden="true"
    >
      <Icon size={icon} strokeWidth={1.8} />
    </span>
  );
};
